import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import cs from './cs.json';

// cs.json holds FLAT keys with literal dots (e.g. "Form.Login.Heading" is one
// key, not nested). `keySeparator: false` makes i18next look them up verbatim
// instead of splitting on '.', so runtime lookups and the compile-time key
// union below agree. (Previously this worked only via i18next's default
// `ignoreJSONStructure` fallback.)
//
// The CustomTypeOptions augmentation types every `t('…')` call against the
// keys actually present in cs.json — a typo or drifted key is now a compile
// error. `keySeparator: false` here MUST mirror the runtime init.
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
    defaultNS: 'translation';
    keySeparator: false;
    resources: {
      translation: typeof cs;
    };
  }
}

/** Every valid translation key — the flat literal union of cs.json's keys. */
export type TransKey = keyof typeof cs;

i18n.use(initReactI18next).init({
  lng: 'cs',
  fallbackLng: 'cs',
  debug: false,
  returnNull: false,
  keySeparator: false,
  resources: {
    cs: {
      translation: cs,
    },
  },
});

export default i18n;
